import { render, staticRenderFns } from "./UnassignedUnitsForm.vue?vue&type=template&id=d582582a&scoped=true"
import script from "./UnassignedUnitsForm.vue?vue&type=script&lang=js"
export * from "./UnassignedUnitsForm.vue?vue&type=script&lang=js"
import style0 from "./UnassignedUnitsForm.vue?vue&type=style&index=0&id=d582582a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d582582a",
  null
  
)

export default component.exports